var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['sign-in-overlay', {'sign-in-overlay--inactive': !_vm.showOverlay}]})
}
var staticRenderFns = []

export { render, staticRenderFns }